import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Confirm } from 'semantic-ui-react'

const propTypes = {
};

const defaultProps = {
};

class ConfirmContent extends Component {

  constructor(props) {
    super(props);
  }

  render() {

    const { confirmShow, openFunc, text, style, cancelButton, confirmButton } = this.props;
    return(

      <div>
        <Confirm
          open={confirmShow}
          content={text}
          onCancel={(e) => openFunc(false, false)}
          onConfirm={(e) => openFunc(false, true)}
          cancelButton={cancelButton}
          confirmButton={confirmButton}
          style={style}
        />
      </div>

    );
  }
}

ConfirmContent.propTypes = propTypes;
ConfirmContent.defaultProps = defaultProps;

export default ConfirmContent;
